import React, { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api, formatErr } from "../lib/api";
import { toast } from "sonner";
import { ArrowRight, Lock } from "lucide-react";

const QV_LOGO =
  "https://customer-assets.emergentagent.com/job_athletic-edge-19/artifacts/7jyn9i1w_IMG_2453.PNG";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(token ? "" : "Enlace inválido: falta el token.");

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("La contraseña debe tener al menos 6 caracteres.");
    if (password !== confirm) return toast.error("Las contraseñas no coinciden.");
    setSubmitting(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      navigate("/app/login?reset=ok", { replace: true });
    } catch (err) {
      setError(formatErr(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="qv-login-wrap" data-testid="reset-password-page">
      <div className="qv-login-card">
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 24 }}>
          <img src={QV_LOGO} alt="QV" style={{ width: 44, height: 44, objectFit: "contain" }} />
          <div style={{ fontFamily: "Bebas Neue", fontSize: 18 }}>QUIQUE VARGAS</div>
        </div>
        <div className="qv-overline" style={{ marginBottom: 8 }}>Recuperar acceso</div>
        <h1 className="qv-display" style={{ fontSize: "2.4rem", lineHeight: 0.95, marginBottom: 24 }}>
          NUEVA<br/><span style={{ color: "var(--qv-red)" }}>CONTRASEÑA.</span>
        </h1>

        {error ? (
          <div data-testid="reset-password-error" style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <p style={{ color: "#fca5a5", fontSize: 14 }}>{error}</p>
            <Link to="/app/login?forgot=1" className="qv-btn-primary" style={{ justifyContent: "center" }} data-testid="reset-password-request-new">
              SOLICITAR NUEVO ENLACE
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 16 }} data-testid="reset-password-form">
            {[["Nueva contraseña", password, setPassword, "reset-password-input"],
              ["Confirma contraseña", confirm, setConfirm, "reset-password-confirm-input"]].map(([label, val, set, tid]) => (
              <div className="qv-field" key={tid}>
                <label>{label}</label>
                <div style={{ position: "relative" }}>
                  <Lock size={16} style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", color: "#737373" }} />
                  <input type="password" required minLength={6} value={val} onChange={(e) => set(e.target.value)}
                    style={{ paddingLeft: 38 }} placeholder="Mínimo 6 caracteres" autoComplete="new-password" data-testid={tid} />
                </div>
              </div>
            ))}
            <button type="submit" disabled={submitting} className="qv-btn-primary" style={{ justifyContent: "center", marginTop: 6 }} data-testid="reset-password-submit">
              {submitting ? "GUARDANDO..." : "GUARDAR CONTRASEÑA"}
              {!submitting && <ArrowRight size={16} />}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
